module.exports = __webpack_public_path__ + "static/media/pass-success.c470dc91.svg";